<template></template>
<script>
export default {
  name: 'Notifier',
  methods: {
    showSavedFormNotification () {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'As informações foram salvas!' })
    },
    showErrorNotification () {
      this.$notify({ type: 'error', title: 'Ocorreu um erro', text: 'Verifique se as informações foram preenchidas corretamente e tente novamente.' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Notifier.vue?1ba18d46